export default {
      id: "ic_instagram-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_instagram-usage",
      toString: function () {
        return this.url;
      }
    }